import * as React from 'react';
import { notifyEsales } from '.';
import { cartUpdateEvent, isAddLineItemCommand } from '@avensia/excite-commercetools/cart/command';

export function useEsalesCartNotifications() {
  React.useEffect(
    () =>
      cartUpdateEvent.on(async data => {
        if (data.commandEventData?.itemIdentifier && isAddLineItemCommand(data.command)) {
          const ticket = data.commandEventData.itemIdentifier;
          notifyEsales('adding-to-cart', ticket);
        }
      }),
    [],
  );
}
